import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import {
  renderFieldRadio,
  renderFieldText,
  renderFieldTextarea,
  renderHiddenFieldText,
  validateEmail,
  classNames,
  startsWithcaseIncincitive,
} from "@basecomponent";
import LocaleStrings from "@language";
import {
  fetchMyProfile,
  updatePersonalInfo,
  openPasswordModal,
  fetchLocationSuggestion,
  locationDetails,
} from "@personalinfoaction";
import { fetchPurchaseTransaction } from "@transactionaction";
import CompanyInfo from "./company-info";
import ChangePassword from "./change-password";
import GoogleMapReact from "google-map-react";
import AsyncSelect from "react-select/async";
import toast from "react-hot-toast";

const PersonalInfo = (props) => {
  var {
    handleSubmit,
    pristine,
    invalid,
    submitting,
    session,
    myProfile,
    changePassword,
    initialValues,
    localeLanguage,
    eventData,
  } = props;
  var [loading, setLoading] = useState(false);
  var [notifylowcredit, setNotifylowcredit] = useState(false);
  var [isCompany, setIsCompany] = useState(false);
  var [receiveinvoice, setReceiveinvoice] = useState(false);
  var [invoiceEmail, setInvoiceEmail] = useState("");
  var [address, setAddress] = useState({ label: "", name: "", placeid: "" });
  var [billing, setBilling] = useState({ label: "", name: "", placeid: "" });
  var [center, setCenter] = useState({
    lat: "",
    lng: "",
  });
  var [billingCountry, setBillingCountry] = useState("");

  useEffect(() => {
    props.fetchMyProfile(session, (res) => {
      //console.log("res", res);
      if (
        res.data &&
        res.data.appuser_additional_info_by_useridfk &&
        res.data.appuser_additional_info_by_useridfk.length > 0
      ) {
        setNotifylowcredit(
          res.data.appuser_additional_info_by_useridfk[0].notifylowcredit == "1"
            ? true
            : false
        );

        setReceiveinvoice(
          res.data.appuser_additional_info_by_useridfk[0].notifyinvoice == "1"
            ? true
            : false
        );
        setInvoiceEmail(
          res.data.appuser_additional_info_by_useridfk[0].notifyinvoiceemail
            ? res.data.appuser_additional_info_by_useridfk[0].notifyinvoiceemail
            : ""
        );

        setAddress({
          label: res.data.appuser_additional_info_by_useridfk[0].location,
          name: res.data.appuser_additional_info_by_useridfk[0].location,
          placeid: res.data.appuser_additional_info_by_useridfk[0].placeid,
        });
        setBilling({
          label:
            res.data.appuser_additional_info_by_useridfk[0].billing_address,
          name: res.data.appuser_additional_info_by_useridfk[0].billing_address,
          placeid: 1,
        });
        setBillingCountry(
          res.data.appuser_additional_info_by_useridfk[0].billing_country
        );

        setCenter({
          lat: res.data.appuser_additional_info_by_useridfk[0].latitude,
          lng: res.data.appuser_additional_info_by_useridfk[0].longitude,
        });
      }

      setIsCompany(res?.data?.iscompanyhr ? true : false);
    });
    //console.log("eventData", eventData);
    let pobj = {};
    pobj.startdate = "";
    pobj.enddate = "";
    pobj.companyid = eventData.useridfk;
    props.fetchPurchaseTransaction(props.session, pobj, "purchase");
  }, [localeLanguage]);

  const onSubmitForm = (values) => {
    setLoading(true);
    let formval = {};
    formval.userid = values.userid;
    formval.name = values.name;
    formval.location = values.location;
    formval.city = values.city;
    formval.state = values.state;
    formval.zipcode = values.zipcode;
    formval.country = values.country;
    formval.placeid = values.placeid;
    formval.latitude = values.latitude;
    formval.longitude = values.longitude;
    formval.jsondata = values.jsondata;
    formval.notifylowcredit = notifylowcredit ? 1 : 0;
    formval.lowcreditthreshold = notifylowcredit
      ? values.lowcreditthreshold
      : null;
    let additionalinfoid =
      values.appuser_additional_info_by_useridfk &&
      values.appuser_additional_info_by_useridfk.length > 0
        ? values.appuser_additional_info_by_useridfk[0].additionalinfoid
        : "";
    // console.log("formval", formval);
    // debugger;
    props.updatePersonalInfo(session, formval, additionalinfoid, (callback) => {
      setLoading(false);
      props.fetchMyProfile(session);
      toast.success("Personal info saved successfully.");
    });
  };

  const updatePassword = () => {
    props.openPasswordModal({ showModal: true });
  };

  const handleLocationChange = (inputValue, callback) => {
    if (inputValue.length > 2) {
      props.fetchLocationSuggestion(props.session, inputValue, (response) => {
        var options = [];
        if (response.success) {
          if (response.result.length > 0) {
            response.result.map((item, index) => {
              options.push({
                name: item.description,
                placeid: item.place_id,
                label: item.description,
              });
            });
          }
          callback(options);
        } else {
          callback(options);
        }
      });
    } else {
      callback(null);
    }
  };

  const handleInputChange = (event) => {
    if (event) {
      props.locationDetails(
        props.session,
        { placeid: event.placeid },
        (data) => {
          if (data.result) {
            var locationData = data.result;

            setCenter({
              lat: locationData.geometry.location.lat,
              lng: locationData.geometry.location.lng,
            });
            setAddress(event);
            processData(locationData, true);
          }
        }
      );
    } else {
      setAddress({ label: "", name: "", placeid: "" });
    }
  };

  const processData = (locationData, onselection) => {
    // debugger;
    var formattedData = formatData(locationData);
    formattedData = {
      ...formattedData,
      location: {
        allData: locationData,
        placeid: locationData.place_id,
        address: locationData.formatted_address,
        lat: locationData.geometry.location.lat,
        lng: locationData.geometry.location.lng,
      },
    };
    populateFields(formattedData, onselection);
  };

  const formatData = (place) => {
    var address = { city: "", state: "", country: "", postalcode: "" };
    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      switch (addressType) {
        case "locality":
          address.city = place.address_components[i].long_name;
          break;
        case "administrative_area_level_1":
          address.state = place.address_components[i].long_name;
          break;
        case "country":
          address.country = place.address_components[i].long_name;
          break;
        case "postal_code":
          address.postalcode = place.address_components[i].long_name;
          break;
      }
    }

    return address;
  };

  const populateFields = (data, onselection) => {
    if (!onselection) props.autofill("city", data.city);
    props.autofill("state", data.state);
    props.autofill("zipcode", data.postalcode);
    props.autofill("country", data.country);
    props.autofill("location", data.location.address);
    props.autofill("placeid", data.location.placeid);
    props.autofill("latitude", data.location.lat);
    props.autofill("longitude", data.location.lng);
    props.autofill("jsondata", JSON.stringify(data.location.allData));
  };

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="bg-white rounded w-full p-6 text-base md:col-span-2">
            <div className="border-b pb-2">
              {LocaleStrings.personal_info_title}
            </div>
            <form
              onSubmit={handleSubmit(onSubmitForm)}
              className="space-y-6 pt-6"
            >
              <div className="space-y-1 ">
                <label for="email" className="control-label-top col-span-12">
                  {LocaleStrings.signup_form_label_email}
                </label>
                <div className="col-span-12 common-field input-field px-3 py-2">
                  {myProfile?.email
                    ? myProfile?.email.startsWith("KY") ||
                      myProfile?.email.startsWith("ky")
                      ? myProfile?.email
                          .substring(0, myProfile?.email.indexOf("@"))
                          .toUpperCase()
                      : myProfile?.email
                    : ""}
                </div>
              </div>

              <Field
                name="name"
                label={LocaleStrings.signup_form_label_fullname}
                type="text"
                component={renderFieldText}
                mandatory="true"
                maxlength={100}
              />

              <Field
                name="placeid"
                type="text"
                component={renderHiddenFieldText}
              />
              <Field
                name="latitude"
                type="text"
                component={renderHiddenFieldText}
              />
              <Field
                name="longitude"
                type="text"
                component={renderHiddenFieldText}
              />
              <Field
                name="country"
                type="text"
                component={renderHiddenFieldText}
              />
              <Field
                name="location"
                type="text"
                component={renderHiddenFieldText}
              />
              <Field
                name="zipcode"
                type="text"
                component={renderHiddenFieldText}
              />
              <Field
                name="jsondata"
                type="text"
                component={renderHiddenFieldText}
              />
              {/* {initialValues.iscompany ? (
                <Field
                  name="locationview"
                  label={LocaleStrings.personalinfo_form_label_address}
                  type="text"
                  component={renderFieldTextarea}
                  maxlength={100}
                  readOnly={true}
                />
              ) : (
                <div className="space-y-1">
                  <label className="sc-bwzfXH dybocD">
                    {LocaleStrings.users_additional_form_label_address}
                  </label>
                  <AsyncSelect
                    value={address.placeid != "" ? address : ""}
                    placeholder={LocaleStrings.users_additional_form_ph_address}
                    name="address"
                    onChange={handleInputChange}
                    loadOptions={handleLocationChange}
                    isClearable
                    className="async-select"
                  />
                </div>
              )} */}

              <div className="space-y-1">
                <label className="sc-bwzfXH dybocD">
                  {LocaleStrings.users_additional_form_label_address}
                </label>
                <AsyncSelect
                  value={address.placeid != "" ? address : ""}
                  placeholder={LocaleStrings.users_additional_form_ph_address}
                  name="address"
                  onChange={handleInputChange}
                  loadOptions={handleLocationChange}
                  isClearable
                  className="async-select"
                />
              </div>

              <div className="space-y-1">
                <div class="flex items-center">
                  <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                    <input
                      type="checkbox"
                      name="toggle"
                      id="lowcredit_notify"
                      className="checkclass"
                      onClick={() => setNotifylowcredit(!notifylowcredit)}
                      style={{ outline: "none" }}
                      checked={notifylowcredit}
                    />
                    <label
                      for="lowcredit_notify"
                      className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer appearance-none focus:outline-none "
                    ></label>
                  </div>
                  <div className="text-black">
                    {
                      LocaleStrings.personalinfo_form_label_lowcredit_notify_title
                    }
                  </div>
                </div>
              </div>

              <Field
                name="lowcreditthreshold"
                label={
                  LocaleStrings.personalinfo_form_label_lowcredit_notify_amount
                }
                type="text"
                component={renderFieldText}
                mandatory="true"
                maxlength={100}
                disabled={notifylowcredit ? false : true}
              />
              <div className="flex items-center justify-end">
                <button
                  type="submit"
                  //disabled={pristine || invalid || submitting || loading}
                  className="bg-managebutton rounded py-2 px-5 w-full flex items-center justify-center"
                >
                  {loading ? (
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  ) : (
                    ""
                  )}
                  {LocaleStrings.save_changes}
                </button>
              </div>
            </form>
            <div className="flex items-center justify-center md:justify-end mt-7">
              <button
                type="button"
                className="bg-gray-200 text-black border border-gray-700 rounded py-2 px-5 w-full md:w-1/2"
                onClick={() => updatePassword()}
              >
                {LocaleStrings.change_password_btn}
              </button>
            </div>
          </div>

          <div className="bg-white rounded w-full p-6 text-base md:col-span-3">
            <CompanyInfo
              isCompany={isCompany}
              setReceiveinvoice={setReceiveinvoice}
              receiveinvoice={receiveinvoice}
              invoiceEmail={invoiceEmail}
              setInvoiceEmail={setInvoiceEmail}
              setIsCompany={setIsCompany}
              billing={billing}
              billingCountry={billingCountry}
              setBillingCountry={setBillingCountry}
            />
          </div>
        </div>
      </div>
      {changePassword.showModal ? <ChangePassword /> : ""}
    </>
  );
};

const validate = (values) => {};

const mapStateToProps = (state) => {
  var init = {};
  if (state.myProfile && state.myProfile.data) {
    init = state.myProfile.data;
    init.location =
      state.myProfile.data &&
      state.myProfile.data.appuser_additional_info_by_useridfk &&
      state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
        ? state.myProfile.data.appuser_additional_info_by_useridfk[0].location
        : "";

    init.city =
      state.myProfile.data &&
      state.myProfile.data.appuser_additional_info_by_useridfk &&
      state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
        ? state.myProfile.data.appuser_additional_info_by_useridfk[0].city
        : "";
    init.state =
      state.myProfile.data &&
      state.myProfile.data.appuser_additional_info_by_useridfk &&
      state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
        ? state.myProfile.data.appuser_additional_info_by_useridfk[0].state
        : "";
    init.zipcode =
      state.myProfile.data &&
      state.myProfile.data.appuser_additional_info_by_useridfk &&
      state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
        ? state.myProfile.data.appuser_additional_info_by_useridfk[0].zipcode
        : "";
    init.country =
      state.myProfile.data &&
      state.myProfile.data.appuser_additional_info_by_useridfk &&
      state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
        ? state.myProfile.data.appuser_additional_info_by_useridfk[0].country
        : "";
    init.placeid =
      state.myProfile.data &&
      state.myProfile.data.appuser_additional_info_by_useridfk &&
      state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
        ? state.myProfile.data.appuser_additional_info_by_useridfk[0].placeid
        : "";
    init.latitude =
      state.myProfile.data &&
      state.myProfile.data.appuser_additional_info_by_useridfk &&
      state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
        ? state.myProfile.data.appuser_additional_info_by_useridfk[0].latitude
        : "";
    init.longitude =
      state.myProfile.data &&
      state.myProfile.data.appuser_additional_info_by_useridfk &&
      state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
        ? state.myProfile.data.appuser_additional_info_by_useridfk[0].longitude
        : "";
    init.jsondata =
      state.myProfile.data &&
      state.myProfile.data.appuser_additional_info_by_useridfk &&
      state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
        ? state.myProfile.data.appuser_additional_info_by_useridfk[0].jsondata
        : "";
    init.lowcreditthreshold =
      state.myProfile.data &&
      state.myProfile.data.appuser_additional_info_by_useridfk &&
      state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
        ? state.myProfile.data.appuser_additional_info_by_useridfk[0]
            .lowcreditthreshold
        : "";
    init.iscompany = state.myProfile.data.iscompanyhr;
    if (state.myProfile.data.iscompanyhr)
      init.locationview =
        state.myProfile.data &&
        state.myProfile.data.appuser_additional_info_by_useridfk &&
        state.myProfile.data.appuser_additional_info_by_useridfk.length > 0
          ? state.myProfile.data.appuser_additional_info_by_useridfk[0].location
          : "";
  }

  //console.log("init", init);
  return {
    session: state.session,
    initialValues: init,
    myProfile: state.myProfile.data,
    changePassword: state.changePassword,
    localeLanguage: state.localeLanguage,
    eventData: state.eventData,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchMyProfile,
      updatePersonalInfo,
      openPasswordModal,
      fetchLocationSuggestion,
      locationDetails,
      fetchPurchaseTransaction,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "PersonalinfoForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(PersonalInfo)
);
